@if (!!simpleLabel) { @if (isNowDateContainer(simpleLabel)) {
<p class="m-0">
  {{ simpleLabel }}
</p>
} @else { @switch (intervalType) { @case (deliveryWindowType.Week) {
<p class="m-0">
  <span i18n="Config Strip|week delivery label@@weekDeliveryLabel" class="mr-1"
    >W{{ simpleLabel | date: 'ww' }}</span
  ><span>{{ getYearForWeekDate(weekRange.from) }}</span
  ><br />
  <span class="font-size-sm"
    >{{ weekRange.from | date: 'dd.MM.yyyy' }} -
    {{ weekRange.to | date: 'dd.MM.yyyy' }}</span
  >
</p>
} @case (deliveryWindowType.Day) {
<p class="m-0">
  {{ simpleLabel | date: 'mediumDate' }}
</p>
} @case (deliveryWindowType.Month) {
<p class="m-0">
  {{ simpleLabel | date: 'MMM yyyy' }}
</p>
} } } } @else { @switch (intervalType) { @case (deliveryWindowType.Week) {
<p data-e2e="delivery-period-date-label" class="m-0 text-truncate">
  <span i18n="Config Strip|week delivery complex from label@@weekDeliveryLabel">
    W{{ complexLabel?.from | date: 'ww yyyy' }}
  </span>
  <span i18n="Config Strip|week delivery complex to label@@weekDeliveryLabel">
    - {{ complexLabel?.to | date: 'ww yyyy' }}
  </span>
</p>
} @case (deliveryWindowType.Day) {
<p
  class="m-0 text-truncate"
  [atxTooltip]="
    (complexLabel?.from | date: 'mediumDate') +
    ' - ' +
    (complexLabel?.to | date: 'mediumDate')
  "
  tooltipPlacement="top"
>
  <span>{{ complexLabel?.from | date: 'mediumDate' }}</span>
  <span> - {{ complexLabel?.to | date: 'mediumDate' }}</span>
</p>
} @case (deliveryWindowType.Month) {
<p class="m-0 text-truncate">
  <span>{{ complexLabel?.from | date: 'MMM yyyy' }}</span>
  <span> - {{ complexLabel?.to | date: 'MMM yyyy' }}</span>
</p>
} } }
